import React from 'react';
import {BuyNowLinkModel} from "../../product-models";


interface BuyNowLinkProps {
    imageHash: string
    imageUrl: string
    resellerName: string
    overlayText: string
    url: string
}


const BuyNowLink = (props:BuyNowLinkProps) => {
    return (
        <a href={props.url} target="_blank" className="buynowitemlink" >
        <img 
            className="buynowitem lazy" 
            alt={props.resellerName} 
            title={props.resellerName} 
            src={`${props.imageUrl}${props.imageHash !== undefined || props.imageHash !== "" ? `?rand=${props.imageHash}` : ""}`} 
        />
            {props.overlayText !== null || props.overlayText !== "" ? <span className="BuyNowOverlay">{props.overlayText}</span> : null}
        </a>
    )
}

export default BuyNowLink